<script setup lang="ts">
import { ref } from 'vue';

interface FAQItem {
    _uid: string;
    question: string;
    answer: string;
}

interface FAQBlok {
    _uid: string;
    headline: string;
    items: FAQItem[];
}

defineProps<{ blok: FAQBlok }>();

const openIndex = ref<number | null>(null);

function toggle(index: number) {
    openIndex.value = openIndex.value === index ? null : index;
}
</script>

<template>
    <section v-editable="blok" class="bg-[#FCF7F4] py-16 xl:py-24">
        <div class="mx-auto max-w-3xl px-4">
            <h2 v-if="blok.headline" class="mb-10 text-center text-[28px] font-semibold leading-tight text-[#004646] xl:mb-14 xl:text-4xl">
                {{ blok.headline }}
            </h2>

            <div class="flex flex-col gap-3">
                <div
                    v-for="(item, index) in blok.items"
                    :key="item._uid"
                    class="overflow-hidden rounded-xl bg-white"
                >
                    <button
                        class="flex w-full items-center justify-between px-6 py-5 text-left text-lg font-semibold text-[#004646] transition hover:bg-gray-50"
                        @click="toggle(index)"
                    >
                        <span>{{ item.question }}</span>
                        <svg
                            class="h-5 w-5 shrink-0 transition-transform duration-200"
                            :class="{ 'rotate-180': openIndex === index }"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                        >
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
                        </svg>
                    </button>
                    <div
                        class="overflow-hidden transition-all duration-200"
                        :class="openIndex === index ? 'max-h-[500px] opacity-100' : 'max-h-0 opacity-0'"
                    >
                        <p class="px-6 pb-5 text-base text-[#393734]">
                            {{ item.answer }}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
